/**
 * Utilidades para resumen IA de tickets largos.
 * Umbral: ≥ 80 palabras (un ticket corto de 1–2 líneas no entra;
 * el ejemplo de desarrollo de retardos/huella sí entra ~150+ palabras).
 */

export const UMBRAL_TICKET_LARGO_PALABRAS = 80

export function contarPalabrasTicket(texto) {
  const t = String(texto || '')
    .replace(/<[^>]+>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
  if (!t) return 0
  return t.split(/\s+/).filter(Boolean).length
}

export function esTicketLargoParaResumen(texto, umbral = UMBRAL_TICKET_LARGO_PALABRAS) {
  return contarPalabrasTicket(texto) >= umbral
}

export function textoMotivoDesdeHistorial(ticket, historial) {
  const lista = Array.isArray(historial) ? historial : []
  const h0 = lista[0] || {}
  const a = String((ticket && ticket.motivo) || '').trim()
  const b = String(h0.motivo || '').trim()
  if (a && b && a === b) return a
  return [a, b].filter(Boolean).join('\n\n')
}
